import React, { useContext } from 'react'
import {dataContext,localestr} from '../utils.js'
import icon from '../icons.svg' 

function EditList({Value,typeVal,setVal,disabled=false,style=undefined,id=undefined}){
    const context=useContext(dataContext)
    const data=context.data[typeVal] || []
    const addTWnd=context.addTWnd

    let currValue=[]
    if(Value){
        if(Array.isArray(Value)) currValue=[...Value]
        else if(typeof Value==='object') currValue=[Value]
    }

    const openWnd=()=>{
        let curVall=undefined
        if(Value){
            if(Array.isArray(Value)){
                if(Value.length) curVall={...Value[Value.length-1]}
            }
            else if(typeof Value==='object') curVall={...Value}
        }

        if(curVall){
            const i=data.findIndex((el)=>el.id===curVall.id)
            if(i!==-1) curVall={...data[i]}
        }
        
        if(curVall&&curVall.parent) addTWnd(localestr('Вибір'),typeVal+'_list',clckHandle,curVall,curVall.parent)
        else addTWnd('Вибір',typeVal+'_list',clckHandle,curVall)
    }

    const clckHandle=(e)=>{
        let newValue=[...currValue]
        newValue.push(e)
        setVal(newValue)
    }

    const delItem=(e)=>{
        let newValue=[...currValue]
        newValue.splice(e,1)
        setVal(newValue)
    }

    const items=currValue.map((el,idx)=>
            <div key={idx} style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit',border:'1px solid',position:'relative',backgroundColor:'white',height:'22px'}}>{el.name}
            <img style={{right:'0px',top:'-1px',width:'24px',height:'24px',position:'absolute',cursor:'pointer',opacity:disabled?0.5:1}} src={icon+'#canBut'} alt='' onClick={()=>delItem(idx)}/></div>
    )

    if(style===undefined) style={display:'inline-flex',width:'100%',fontSize:'inherit',fontFamily:'inherit',padding:'0'}

    return(
        <div id='cat_div' style={{...style,display:'inline-flex',flexDirection:'column'}}>
            {items}
            <div style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit',border:'1px solid',position:'relative',backgroundColor:'white',height:'22px'}}>
            <img style={{right:'1px',top:'-1px',width:'24px',height:'24px',position:'absolute',cursor:'pointer',opacity:disabled?0.5:1}} src={icon+'#cat'} alt='' onClick={openWnd}/>
            </div>
        </div>
    )

}
export default EditList